var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$bem()},[(_vm.$route.path === '/login')?_c('login-form'):(_vm.$route.path === '/reset-password')?_c('reset-password'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }